<template>
  <div v-if="brandId">
    <div class="mb-2">
      <b>Batch Upload CSV</b>
      <div>This will replace all {{ title }}s for this brand.</div>
    </div>

    <slot></slot>

    <button v-if="exampleCsv" class="btn btn-primary mb-2" @click.prevent="downloadExample">
      Download An Example CSV
    </button>

    <div style="width: 400px">
      <b-form-file
        v-model="form.file"
        accept=".csv"
        placeholder="Choose a file or drop it here..."
        drop-placeholder="Drop file here..."
      />
    </div>
    <button
      class="btn btn-primary mt-2"
      :disabled="form.notReady() || !form.file"
      @click.prevent="onSubmit"
    >
      <font-awesome-icon v-if="form.busy" spin :icon="['fal', 'spinner']" />
      <font-awesome-icon v-else :icon="['fal', 'cloud-upload']" />
      Submit
    </button>
  </div>
</template>
<script type="text/babel">
import file from "@/imports/file";

export default {
  props: {
    title: {
      type: String,
      required: true,
    },

    endpoint: {
      type: String,
      required: true,
    },

    exampleCsv: {
      type: String,
      required: false,
      default: null,
    },

    brandId: {
      required: true,
    },
  },

  data() {
    return {
      created: [],
      errors: [],
      crud: null,
      form: new window.AppForm({
        file: null,
      }),
    };
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      this.crud = new window.AppCrud(this.endpoint);

      this.form.reset();
    },

    onSubmit() {
      window
        .sweetAlert({
          title: "Are you sure?",
          text: "Are you sure that you want to replace all " + this.title + "s with this CSV file?",
          icon: "warning",
          dangerMode: true,
          buttons: {
            cancel: "No",
            confirm: "Yes, I'm sure!",
          },
        })
        .then(async (confirmed) => {
          if (confirmed) {
            try {
              this.crud.submit(this.form, "upload").then((response) => {
                if (response.errors) {
                  this.errors = response.errors;
                }

                this.created = response.created;
                window.toastr.success(`${this.title} successfully updated!`, "Success");

                this.$emit("uploaded", response);
              });
            } catch (error) {
              console.error(error);
            }
          }
        });
    },

    downloadExample() {
      file.download(this.exampleCsv, "example.csv");
    },
  },
};
</script>
